<div id="header" class="p-grid" style="min-height: 56px;">

    <p-sidebar [(visible)]="visibleMenu" position="left" [baseZIndex]="10000" styleClass="menu-bar" class="bar-container" [showCloseIcon]="false">
        <div class="p-grid" style="padding-top:30px">

            <div class="p-col-12">
                <p-menu  [model]="collapsedMenuItems" styleClass="menu-admin"></p-menu>
            </div>
            <div class="p-col-12">
                <p-menu *ngIf="showAdministration" [model]="menuItems" styleClass="menu-admin"></p-menu>
            </div>
            <div class="p-col-12">
                <button pButton type="button" label="Se deconnecter" icon="pi pi-sign-out" [style]="menuStyle()" (click)="logout()"></button>
            </div>

        </div>
    </p-sidebar>

    <p-sidebar [(visible)]="visibleSideBar" position="right" [baseZIndex]="10000" styleClass="menu-bar" class="bar-container" [showCloseIcon]="false">
        <div class="p-grid" style="padding-top:30px">

            <div class="p-col-12">
                <p-menu  [model]="profilItems" styleClass="menu-admin"></p-menu>
            </div>
            <div class="p-col-12">
                <p-menu *ngIf="showAdministration" [model]="menuItems" styleClass="menu-admin"></p-menu>
            </div>
            <div class="p-col-12">
                <button pButton type="button" label="Se deconnecter" icon="pi pi-sign-out" [style]="menuStyle()" (click)="logout()"></button>
            </div>


        </div>
    </p-sidebar>

    <p-toolbar [style] = "defaultHeaderStyle()" class="p-col-12 menu">
        <div class="ui-toolbar-group-left">
            <button *ngIf="showModeration" pButton type="button" label="Modération" icon="pi pi-id-card" [style] = "multipleStyle([defaultHeaderStyle(), buttonMenuStyle()])" routerLink="/moderation"></button>
            <button *ngIf="showHistorique" pButton type="button" label="Historique" icon="pi pi-clock" [style] = "multipleStyle([defaultHeaderStyle(), buttonMenuStyle()])" routerLink="/historique"></button>
            <button *ngIf="showReporting" pButton type="button" label="Reporting" icon="pi pi-chart-line" [style] = "multipleStyle([defaultHeaderStyle(), buttonMenuStyle()])" routerLink="/reporting"></button>
            <button *ngIf="showFacturation" pButton type="button" label="Facturation" icon="pi pi-money-bill" [style] = "multipleStyle([defaultHeaderStyle(), buttonMenuStyle()])" routerLink="/facturation"></button>
            <button *ngIf="showSupervision" pButton type="button" label="Supervision" icon="pi pi-eye" [style] = "multipleStyle([defaultHeaderStyle(), buttonMenuStyle()])" routerLink="/supervision"></button>
            <button *ngIf="showPerformance" pButton type="button" label="Performance" icon="pi pi-chart-bar" [style] = "multipleStyle([defaultHeaderStyle(), buttonMenuStyle()])" routerLink="/performance"></button>
        </div>

        <div class="ui-toolbar-group-right">
            <button pButton type="button"  icon="pi pi-briefcase" [style] = "defaultHeaderStyle()" (click)="visibleSideBar = true"></button>

        </div>
    </p-toolbar>

    <i class="pi pi-bars humberger-menu" (click)="afficherMenu()"></i>
</div>




